import { injectable } from 'inversify';
import { StorageError, StorageErrorType, Stringifier } from '@dandelion/core';
import { PreferencesStorageInterface } from '../interfaces/PreferencesStorageInterface';
import { PreferenceValue } from '../entities/Preference';
import { Preferences } from '../enum/Preferences';

@injectable()
export class LocalPreferencesStorage implements PreferencesStorageInterface {
  protected localStorage = window.localStorage;

  constructor(protected key: string, protected defaultPreferences: PreferenceValue[]) {
    if (!this.localStorage.getItem(this.key)) {
      this.saveAllPreferences(this.defaultPreferences);
    }
  }

  async getPreference(name: string): Promise<PreferenceValue> {
    const preferenceValues = await this.getPreferences();
    const preferenceValue = preferenceValues.find((prefValue) => prefValue.preferenceName === name);

    if (preferenceValue) {
      return preferenceValue;
    }

    const defaultPreference = this.defaultPreferences.find(
      (prefValue) => prefValue.preferenceName === name
    );

    if (defaultPreference) {

      await this.savePreference(defaultPreference);
      return defaultPreference;
    }
const preference = Preferences[name as keyof typeof Preferences];

if (!preference) {
  const preference = Object.values(Preferences).includes(name as Preferences)
  ? (name as Preferences)
  : undefined;
  if(!preference)
  throw new Error(`Invalid preference: ${name}`);
}
    return {
      preferenceName: preference,
      value: '',
    };
  }

  async getPreferences(): Promise<Array<PreferenceValue>> {
    let preferenceValues = new Stringifier<PreferenceValue[]>().deserialize(
      this.localStorage.getItem(this.key)!
    );
    if (!preferenceValues) {
      this.saveAllPreferences(this.defaultPreferences);
      preferenceValues = this.defaultPreferences;
    }
    return preferenceValues;
  }

  async saveAllPreferences(preferecesToBeSaved: Array<PreferenceValue>): Promise<void> {
    this.localStorage.setItem(this.key, JSON.stringify(preferecesToBeSaved));
  }

  async savePreference(newPreference: PreferenceValue): Promise<void> {
    const preferenceValues = await this.getPreferences();
    const index = preferenceValues.findIndex(
      (prefValue) => prefValue.preferenceName === newPreference.preferenceName
    );

    if (index !== -1) {
      preferenceValues[index].value = newPreference.value;
    } else {
      preferenceValues.push(newPreference);
    }

    await this.saveAllPreferences(preferenceValues);
  }
}
